module.exports = __webpack_public_path__ + "static/img/product_lotus2r_small.c5888a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product_lotus2r_small.png
// module id = 9gtp
// module chunks = 1